// https://www.lewagon.com/blog/from-jquery-to-dom-and-es6

class FormContact {
    constructor(element) {
        console.log('FormContact.constructor', element);
        this.element = element;
        this.form = this.element.getElementsByTagName('form')[0];
        this.checkboxTerms = document.getElementById('form_terms');
        this.btnSubmit = document.getElementById('submitCheck');
        this.error = this.element.getElementsByClassName('error')[0];
        this.success = this.element.getElementsByClassName('success')[0];

        this.xmlhttp = new XMLHttpRequest();
        //this.xmlhttp.timeout = 10000;
        this.onLoadXMLHttpRequest = this.onLoadXMLHttpRequest.bind(this);
        this.onChangeTerms = this.onChangeTerms.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.checkboxTerms.addEventListener('change', this.onChangeTerms);
        this.xmlhttp.addEventListener('load', this.onLoadXMLHttpRequest);
        this.xmlhttp.ontimeout = this.onLoadXMLHttpRequest;
        this.form.addEventListener('submit', this.onSubmit);
    }

    destroy() {
        console.log('FormContact.destroy');
        this.checkboxTerms.removeEventListener('change', this.onChangeTerms);
        this.form.removeEventListener('submit', this.onSubmit);
        this.xmlhttp.removeEventListener('load', this.onLoadXMLHttpRequest);
        this.xmlhttp = null;
    }

    showError(error) {
        var event = new CustomEvent("grecaptcha-reset", {});
        document.dispatchEvent(event);
        this.success.style.display = 'none';
        this.btnSubmit.style.cursor = 'pointer';
        this.btnSubmit.disabled = false;
        this.error.textContent = error;
        this.error.style.display = 'block';
    }

    showSuccess() {
        this.btnSubmit.style.display = 'none';
        this.success.style.display = 'block';
    }

    onChangeTerms() {
        console.log('FormContact.onChangeTerms');
        this.btnSubmit.disabled = !this.checkboxTerms.checked;
    }

    onSubmit(event) {
        console.log('FormContact.onSubmit', this.form, new FormData(this.form));
        event.preventDefault();

        this.error.style.display = 'none';
        this.btnSubmit.disabled = true;
        this.btnSubmit.style.cursor = 'wait';

        this.xmlhttp.open("POST", "/assets/components/app/contact-form-connector.php", true);
        this.xmlhttp.timeout = 5000;
        this.xmlhttp.send(new FormData(this.form));
    }

    onLoadXMLHttpRequest() {
        console.log('onLoadXMLHttpRequest', this.xmlhttp.readyState, this.xmlhttp.status);
        if (this.xmlhttp.readyState == 4 && this.xmlhttp.status == 200) {
            let response = JSON.parse(this.xmlhttp.responseText);
            if (response.success === 'true') {
                this.showSuccess();
            } else {
                this.showError(response.status);
            }
        } else {
            let status = this.xmlhttp.status;
            if (this.xmlhttp.status === 0) {
                status = 'timeout';
            }
            this.showError(this.element.getAttribute('data-servererror') + ' (' + status + ')');
        }
    }
}

FormContact.elementClassName = 'form-contact';
FormContact.instances = [];
FormContact.init = function () {
    console.log('FormContact.init');
    let elements = document.getElementsByClassName(FormContact.elementClassName);
    for (const element of Array.from(elements)) {
        FormContact.instances.push(new FormContact(element));
    }
    console.log('FormContact.instances.length', FormContact.instances.length);
};

FormContact.onDispose = function () {
    console.log('FormContact.onDispose');
    while (FormContact.instances.length) {
        console.log('FormContact.instances.length', FormContact.instances.length);
        let instance = FormContact.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default FormContact;


if (module.hot) {
    module.hot.dispose(FormContact.onDispose);
}
